import styled from 'styled-components';

import {
  typography,
  size,
  mediaQueries,
  Accordion,
  colors,
  H3,
} from '@everlywell/leaves';

const Heading = styled(Accordion.Heading)`
  padding: ${size.md}px 0;
  border-top: 1px solid ${colors.gray2};
`;

const Title = styled.span`
  ${typography.buttonTextSmall};
  text-align: left;

  + div {
    color: ${colors.green5};
  }
`;

const Content = styled(Accordion.Child)`
  ${typography.bodyText}
  padding-bottom: ${size.lg}px;

  a {
    text-decoration: none;
    ${typography.buttonText};
    color: ${colors.green5};
    font-weight: ${typography.weight.book};
  }

  ol {
    li {
      display: list-item;
      list-style-position: inside;
    }
  }
`;

const SectionHeader = styled(H3)`
  text-align: center;
  margin-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: ${size.xl3}px;
  }
`;

const Row = styled.div`
  justify-content: center;
  width: 100%;
  max-width: 54rem;
  margin: 0 auto;
  &:last-of-type {
    border-bottom: 1px solid ${colors.gray2};
  }
`;

export { Title, Heading, Content, SectionHeader, Row };
